var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgVerifiedDeprecated = function SvgVerifiedDeprecated(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 18 18",
    role: "presentation",
    "aria-hidden": true,
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#010101",
    fillRule: "evenodd",
    d: "M2 3.05v6.22C2 15.63 9 17 9 17s7-1.37 7-7.73V3.05L9 1zm9.94 2.47c.19-.18.49-.17.67.02.16.18.16.45.02.63l-4.22 5.11-.03.04c-.28.34-.79.39-1.13.11a.3.3 0 0 1-.077-.067l-.023-.023-1.81-2.08c-.2-.24-.18-.6.06-.8.2-.18.49-.18.7-.04l1.57 1.1z",
    clipRule: "evenodd"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgVerifiedDeprecated);
export { ForwardRef as Icon };
export default "img/e2e/verified-deprecated.9030dfd.svg";